const hr = {
  questionPaperLibrary: "Biblioteka upitnika",
  questionPaperLibraryDescription:
    "Vas dinamican radni prostor za izradu pojedinacnih pitanja i dizajniranje sveobuhvatnih upitnika.",
  assessmentLibrary: "Biblioteka procjena",
  assessmentLibraryDescription:
    "Upravljajte rasporedima, pozivajte sudionike i pratite izvjestaje o ucinku u jednom centraliziranom centru.",
  myAssessmentWidgetTitle: "Moja procjena",
  myPreferences: "Moje postavke",
  assessmentsForYou: "Procjene za vas",
  exploreAssessmentsAssignedToYou: "Istrazite procjene dodijeljene vama",
  hitachiAcademy: "Hitachi akademija",
  essentialBusinessKnowledgeTestForYou: "Osnovni test poslovnog znanja za vas",
  continuousLearningJourneyDescription:
    "Osmišljeno kako bi vam pomoglo razumjeti i ojačati poslovne vještine tijekom kontinuiranog učenja",
  noActiveAssessmentsScheduledForYou: "Nema aktivnih procjena zakazanih za vas",
  upcoming: "Nadolazece",
  notAttempted: "Nije pokusano",
  myAssessmentCardDescription:
    "Ova procjena vrednuje vase tehnicke, analiticke i vjestine rjesavanja problema kao dio GlobalLogicovog procesa kampusnog zaposljavanja.",
  totalDuration: "Ukupno trajanje",
  startTime: "Vrijeme pocetka",
  questionAuthoring: "Izrada pitanja",
  reviewQuestions: "Pregledaj pitanja",
  bulkUploadHistory: "Povijest skupnog prijenosa",
  bulkActionHistory: "Povijest skupnih radnji",
  editQuestion: "Uredi pitanje",
  inviteParticipants: "Pozovi sudionike",
  externalUserBulkUploadHistory:
    "Povijest skupnog prijenosa vanjskih korisnika",
  assessmentSchedule: "Raspored procjene",
  assessmentReport: "Izvjesce o procjeni",
  bulkHistory: "Skupna povijest",
  myUpload: "Moje ucitavanje",
  bulkUpload: "Skupno ucitavanje",
  createQuestion: "Izradi pitanje",
  bulkUploadQuestions: "Skupno ucitavanje pitanja",
  filters: "Filteri",
  clear: "Ocisti",
  searchByTitle: "Pretrazi po naslovu",
  refresh: "Osvjezi",
  refreshing: "Osvjezavanje",
  reviewQuestionPapers: "Pregledaj upitnike",
  myQuestionPapers: "Moji upitnici",
  viewQuestionBank: "Prikazi banku pitanja",
  createNew: "Kreiraj novo",
  sortBy: "Sortiraj po",
  state: "Status",
  reviewed: "Pregledano",
  reviewedTooltip: "Prikazi upitnike koji su pregledani i zatim objavljeni.",
  all: "Sve",
  draft: "Skica",
  published: "Objavljeno",
  inReview: "U pregledu",
  sentBack: "Vraceno",
  readyToPublish: "Spremno za objavu",
  draftDescription:
    "Izrada upitnika je jos u tijeku i jos nije dostupna polaznicima",
  publishedDescription: "Upitnik je aktivan i dostupan polaznicima",
  inReviewDescription: "Upitnik je u pregledu i jos nije odobren",
  sentBackDescription: "Upitnik je vracen na doradu",
  readyToPublishDescription: "Upitnik je spreman za objavu",
  createdAt: "Kreirano",
  updatedAt: "Azurirano",
  publishedAt: "Objavljeno",
  descending: "Silazno",
  ascending: "Uzlazno",
  success: "Uspjeh",
  error: "Pogreška",
  warning: "Upozorenje",
  info: "Informacije",
  yes: "Da",
  no: "Ne",
  noMatchingContentFound: "Nema odgovarajuceg sadrzaja",
  noQuestionPapersAvailableForReview: "Nema dostupnih upitnika za pregled",
  questionPaperNotYetCreated: "Upitnik jos nije kreiran",
  createQuestionPaperDescription:
    "Kreirajte upitnik za procjenu vjestina i znanja polaznika",
  createYourFirstQuestionPaper: "Kreirajte svoj prvi upitnik",
  createQuestionPaperModalTitle: "Kreiraj upitnik",
  questionsTab: "Pitanja",
  questionPaperSettingsTab: "Postavke papira s pitanjima",
  editQuestionPaper: "Uredi upitnik",
  save: "Spremi",
  publish: "Objavi",
  sendForReview: "Pošaljite na pregled",
  sendingForReview: "Slanje na pregled",
  publishing: "Objavljivanje",
  clone: "Klon",
  delete: "Izbrisati",
  view: "Pogled",
  edit: "Uredi",
  close: "Zatvori",
  create: "Kreiraj",
  creating: "Stvaranje",
  confirm: "Potvrdi",
  cancel: "Odustani",
  version: "Verzija",
  untitled: "Bez naslova",
  noVersion: "Nema verzije",
  title: "Titula",
  status: "Status",
  action: "Akcijski",
  createdBy: "Stvorio",
  createNewVersion: "+ Nova verzija",
  createNewVersionTitle: "Stvori novu verziju",
  deleteQuestionPaperPrompt:
    "Jeste li sigurni da želite izbrisati ovaj upitnik?",
  deleteQuestionPaperWithTitlePrompt:
    "Želite li izbrisati ovaj upitnik pod nazivom '{{title}}'?",
  cloneQuestionPaperPrompt: "Želite li klonirati ovaj upitnik?",
  publishQuestionPaperPrompt:
    "Jeste li sigurni da želite objaviti ovaj upitnik?",
  sendForReviewQuestionPaperPrompt:
    "Jeste li sigurni da želite poslati ovaj upitnik na pregled?",
  successfullyDeletedQuestionPaper: "Uspješno izbrisan upitnik",
  successfullyMovedQuestionPaperToDraft:
    "List s pitanjima uspješno je premješten u nacrt",
  successfullySavedQuestionPaperData: "Podaci upitnika uspješno su spremljeni",
  successfullyClonedQuestionPaper: "Uspješno kloniran upitnik",
  successfullyCreatedQuestionPaper: "Uspješno kreiran upitnik",
  validationFailedWithFollowingErrors:
    "Validacija nije uspjela sa sljedećim pogreškama:",
  failedStatusUpdateOf: "Neuspjelo ažuriranje statusa za:",
  savedWithFollowingWarnings: "Spremljeno sa sljedećim upozorenjima:",
  reviewedAndPublished: "Pregledano i objavljeno",
  deleting: "Brisanje...",
  cloning: "Kloniranje...",
  assessment: "Procjena",
  public: "Javnost",
  private: "Privatno",
  visibility: "Vidljivost",
  questionType: "Vrsta pitanja",
  selectQuestionTypeAndVisibility: "Odaberite vrstu pitanja i vidljivost",
  singleChoice: "Jedan izbor",
  multipleChoice: "Višestruki izbor",
  trueOrFalse: "Točno ili netočno",
  fillInTheBlanks: "Ispunite praznine",
  codingQuestion: "Pitanje kodiranja",
  subjectiveQuestion: "Subjektivno pitanje",
  speakingQuestion: "Govorno pitanje",
  downloadTemplateEditAndReuploadQuestions:
    "Preuzmite predložak, uredite i ponovno prenesite popis pitanja",
  downloadExcelTemplateInstruction:
    "Preuzmite Excel predložak pomoću gumba u nastavku.",
  addQuestionsToSheetInstruction:
    "Dodajte svoja pitanja na list (upute su uključene unutra).",
  uploadCompletedExcelInstruction:
    "Prenesite dovršenu Excel datoteku za skupni uvoz pitanja.",
  uploading: "Prijenos...",
  uploadQuestions: "Prijenos pitanja",
  completed: "Završeno",
  invalid: "Neispravno",
  initiated: "Pokrenuto",
  failed: "nije uspjelo",
  fileName: "Naziv datoteke",
  templateType: "Vrsta predloška",
  uploadedAt: "Učitano na",
  actions: "Radnje",
  mcqTemplate: "MCQ predložak",
  fibTemplate: "FIB predložak",
  monitorUploadExcelDescription:
    "Pratite svaku učitanu Excel datoteku, provjerite koliko je pitanja dodano ili neuspješno i po potrebi pogledajte pojedinosti o pogrešci.",
  reset: "Resetiraj",
  showing: "Pokazivanje",
  to: "do",
  of: "od",
  results: "rezultate",
  noExcelFound: "Excel nije pronađen",
  cloneAssessmentConfirmation: "Potvrda procjene klona",
  cloneAssessmentWithTitlePrompt:
    "Jeste li sigurni da želite klonirati ovu procjenu pod nazivom '{{title}}'?",
  successfullyClonedAssessment: "Procjena je uspješno klonirana",
  newVersionContentPrompt:
    "Upravo ćete izraditi novu verziju ovog sadržaja. Sve daljnje promjene bit će spremljene u ovoj verziji. Želite li nastaviti?",
  createVersionWithNumber: "Stvori (V{{version}})",
  addYourComment: "Dodajte svoj komentar",
  maxLimitReached: "dosegnuto maksimalno ograničenje",
  deleteContentPrompt:
    "Jeste li sigurni da želite izbrisati ovaj {{contentType}}?",
  deleteContentWithTitlePrompt:
    "Jeste li sigurni da želite izbrisati ovaj {{contentType}} pod nazivom '{{title}}'?",
  schedulePreview: "Pregled rasporeda",
  reschedule: "Ponovo rasporedite",
  cancelled: "Otkazano",
  copyLink: "Kopiraj vezu",
  assessmentIsCancelled: "Ocjenjivanje je poništeno",
  deleteConfirmation: "Potvrda brisanja",
  cancelConfirmation: "Odustani od potvrde",
  deleteAssessmentPrompt: "Jeste li sigurni da želite izbrisati ovu procjenu?",
  cancelAssessmentPrompt: "Jeste li sigurni da želite otkazati ovu procjenu?",
  rescheduleAssessment: "Odgoditi procjenu",
  customTermsAndConditions: "Prilagođeni uvjeti i odredbe",
  viewTermsAndConditions: "Pogledajte uvjete i odredbe",
  scheduleNewAssessment: "Zakažite novu procjenu",
  selectQuestionPaper: "Odaberite List s pitanjima",
  createAssessment: "Napravite procjenu",
  failedToLoadData: "Učitavanje podataka nije uspjelo!",
  assessmentNotYetCreated: "Procjena još nije izrađena",
  createAssessmentDescription:
    "Napravite procjenu za procjenu vještina i znanja učenika",
  createYourFirstAssessment: "Napravite svoju prvu procjenu",
  failedToLoadSchedules: "Učitavanje rasporeda nije uspjelo",
  errors: "greške:",
  basicInformation: "Osnovne informacije",
  assessmentName: "Naziv procjene",
  na: "NA",
  scheduleInstructions: "Upute za raspored",
  noInstructionsProvided: "Nema uputa",
  accessCriteria: "Kriteriji pristupa",
  searchTags: "Oznake za pretraživanje",
  viewAttributes: "Prikaz atributa",
  termsAndConditions: "Odredbe i uvjeti",
  enabled: "Omogućeno",
  disabled: "Onesposobljeno",
  requireCandidatesToAcceptTerms:
    "Zahtijevati od kandidata da prihvate T&C prije početka ocjenjivanja",
  proctoringSettings: "Proctoring postavke",
  enableVideoProctoring: "Omogući Video Proctoring",
  maximumVideoViolationsAllowed:
    "Maksimalno dopušteno kršenje pravila videozapisa",
  enableBrowserProctoring: "Omogući zaštitu preglednika",
  maximumBrowserViolationsAllowed:
    "Maksimalno dopušteno kršenje pravila preglednika",
  displayViolationsToCandidates: "Prikažite prekršaje kandidatima",
  actionWhenViolationLimitReached: "Radnja kada se dosegne granica kršenja",
  flagged: "Označeno",
  terminate: "Otkazati",
  stakeholdersAndFeedback: "Dionici i povratne informacije",
  owner: "Vlasnik",
  recruiter: "Regrut",
  allowCandidateFeedback: "Dopusti povratne informacije kandidata",
  enableCandidateFeedbackDescription:
    "Omogućite kandidatima slanje povratnih informacija nakon završetka procjene",
  schedulingAndTimerSettings: "Zakazivanje i postavke mjerača vremena",
  scheduleType: "Vrsta rasporeda",
  loginWindow: "Prozor za prijavu",
  durationBased: "Na temelju trajanja",
  deadline: "Rok",
  autoCompleteMode: "Način automatskog dovršavanja",
  startDateAndTime: "Datum i vrijeme početka",
  loginWindowInMinutes: "Prozor za prijavu (u minutama)",
  endDateAndTime: "Datum i vrijeme završetka",
  timerEnabled: "Odbrojavanje omogućeno",
  assessmentRules: "Pravila ocjenjivanja",
  assessmentPattern: "Obrazac ocjenjivanja",
  resultVisibility: "Vidljivost rezultata",
  passPercentage: "Postotak prolaza",
  maximumAttemptsAllowed: "Maksimalni dopušteni pokušaji",
  unlimitedAttempts: "Neograničeni pokušaji",
  attempt: "pokušaj",
  attempts: "pokušaja",
  coolOffPeriodBetweenAttempts: "Razdoblje hlađenja između pokušaja",
  questionDisplaySettings: "Postavke prikaza pitanja",
  showQuestionTitle: "Prikaži naslov pitanja",
  showQuestionTitleDescription: "Prikažite naslov pitanja iznad svakog pitanja",
  showHint: "Prikaži savjet",
  hintLoading: "Morate pričekati prije nego što vidite drugi savjet",
  allHintsShown: "Nema preostalih savjeta",
  showHintDescription: "Omogućite savjete za pomoć kandidatu tijekom procjene",
  showExplanation: "Prikaži objašnjenje",
  hideExplanation: "Sakrij objašnjenje",
  showExplanationDescription: "Prikaži objašnjenja nakon svakog slanja pitanja",
  showQuestionMarks: "Prikaži upitnike",
  showQuestionMarksDescription:
    "Prikažite vrijednost ocjene/boda za svako pitanje",
  showWatermark: "Prikaži vodeni žig",
  showWatermarkDescription:
    "Prikažite e-mail kandidata za svako pitanje kao vodeni žig",
  questionPaperPreview: "Pregled rada s pitanjima",
  questionPaperReview: "Pregled rada s pitanjima",
  createSchedule: "Napravite raspored",
  reviewerComments: "Komentari recenzenta",
  reviewComments: "Pregledajte komentare",
  sendBackQuestionPaperPrompt:
    "Jeste li sigurni da želite vratiti ovaj upitnik?",
  moveQuestionPaperToDraftPrompt:
    "Jeste li sigurni da želite premjestiti ovaj upitnik u nacrt?",
  markQuestionPaperReadyToPublishPrompt:
    "Jeste li sigurni da želite označiti ovaj upitnik spremnim za objavljivanje?",
  questionPaperStatusUpdatedSuccessfully:
    "Status papira s pitanjima uspješno je ažuriran!",
  newVersionQuestionPaperCreatedSuccessfully:
    "Nova verzija za upitnik uspješno je izrađena!",
  questionPaperClonedSuccessfully: "Upitnik je uspješno kloniran!",
  startAddingQuestionsPreview:
    "Počnite dodavati pitanja da biste ih pregledali ovdje",
  bulkInviteParticipants: "Skupno pozovite sudionike",
  bulkInviteParticipantsDescription:
    "Pozovite više sudionika odjednom učitavanjem unaprijed ispunjene Excel datoteke. Upotrijebite dostavljeni predložak kako biste osigurali točan format.",
  maxParticipantsPerFileNote:
    "Maksimalno 200 sudionika po datoteci. Dvostruki ili nevažeći unosi bit će preskočeni s pogreškom.",
  downloadTemplate: "Preuzmite predložak",
  creatingUser: "Stvaranje korisnika...",
  bulkInviteLabel: "Skupni poziv",
  createAndInvite: "Stvorite i pozovite",
  myUploads: "Moji prijenosi",
  enterIndividualsForInvite:
    "Unesite imena jedne ili više osoba koje želite pozvati na procjenu",
  searchPeopleByEmailOrName: "Pretraži osobe po e-mailu ili imenu",
  noResultsFound: "Nema rezultata",
  loading: "Učitavanje..",
  or: "Ili",
  multipleEmailsInviteDescription:
    "Dodajte više e-adresa korisnika, odvojenih zarezima, da biste pozvali više korisnika na procjenu",
  addCandidates: "Dodajte kandidate",
  pleaseEnterValidNameOrEmail: "Unesite važeće ime ili adresu e-pošte",
  pleaseEnterValidEmailAddress: "Molimo unesite valjanu adresu e-pošte",
  someEmailsCouldNotBeAdded: "Neke adrese e-pošte nije bilo moguće dodati",
  checkInvalidEmailIds:
    "Provjerite sljedeće ID-ove e-pošte - čini se da nisu valjani:",
  failedToSendInvitesFollowingEmails:
    "Slanje pozivnica na sljedeće adrese e-pošte nije uspjelo:",
  successfullyInvitedMembers: "Uspješno pozvan {{count}} član",
  validationFailed: "Validacija nije uspjela",
  excelUploadedSuccessfully: "Excel je uspješno prenesen",
  invalidBulkNominationTemplate: "Nevažeći predložak skupne nominacije",
  actionCompletedWithWarnings: "Radnja je dovršena sa sljedećim upozorenjima:",
  actionFailedWithErrors:
    "Radnja se nije mogla dovršiti i izaći sa sljedećim pogreškama:",
  trackBulkOperationsAndResults:
    "Pratite sve svoje skupne operacije i njihove rezultate",
  partiallySaved: "Djelomično spremljeno",
  statusInitiatedDescription:
    "Zahtjev za ažuriranje pitanja je predan i obrađuje se.",
  statusCompletedDescription: "Sva odabrana pitanja su uspješno ažurirana.",
  statusFailedDescription:
    "Niti jedno od odabranih pitanja nije bilo uspješno obrađeno.",
  statusPartiallySavedDescription:
    "Neka su pitanja uspješno spremljena, dok su druga naišla na probleme.",
  draftReadyToPublishToPublish: "Nacrt/Spremno za objavu -> Objavi",
  actionType: "Vrsta akcije",
  uploadedOn: "Učitano",
  viewDetails: "Prikaži pojedinosti",
  loadingRecords: "Učitavanje zapisa...",
  noRecordsFound: "Nema pronađenih zapisa",
  recordsPerPage: "Zapisi po stranici:",
  page: "Stranica",
  untitledQuestion: "Pitanje bez naslova",
  globalLogic: "GlobalLogic",
  aiGenerated: "AI Genered",
  fullScreen: "Cijeli zaslon",
  exitFullScreen: "Izlaz iz cijelog zaslona",
  skills: "Vještine",
  tags: "oznake",
  allowedCodingLanguages: "Dopušteni jezici kodiranja",
  marks: "Oznake",
  lastUpdatedAt: "Zadnje ažuriranje u",
  solutionCode: "Šifra rješenja",
  solution: "Otopina",
  starterCode: "Početni kod",
  options: "Mogućnosti",
  explanation: "Obrazloženje",
  hint: "Savjet",
  deleteQuestion: "Obriši pita nje",
  noSections: "Nema dodanih odjeljaka",
  editAndPublish: "Uredi i objavi",
  sendBackToDraftInstruction:
    "Kliknite gumb za slanje natrag kako biste poslali pitanje natrag u nacrt.",
  updateStatusReadyToPublishInstruction:
    "Kliknite gumb Spremno za objavu da ažurirate status.",
  successfullyUpdatedStatus: "Uspješno ažuriran status",
  dismiss: "Odbaciti",
  ongoing: "U tijeku",
  toBeLaunched: "Uskoro se pokreće",
  contentExpired: "Sadržaj je istekao",
  notApplicable: "Nije primjenjivo",
  expiresSoon: "Istječe uskoro",
  contentCreationInProgressTooltip:
    "Izrada sadržaja je još u tijeku i još nije dostupna polaznicima",
  contentLiveAccessibleTooltip: "Sadržaj je aktivan i dostupan polaznicima",
  contentAvailableWithinDatesTooltip:
    "Sadržaj je trenutno dostupan jer je unutar datuma početka i isteka",
  contentNotLaunchedAvailableOnTooltip:
    "Sadržaj još nije pokrenut i bit će dostupan",
  contentExpiredOnTooltip: "Ovaj sadržaj je istekao",
  statusAvailableAfterPublishTooltip:
    "Status će biti dostupan kada sadržaj bude objavljen",
  contentExpiresWithin48HoursTooltip: "Sadržaj će isteći unutar 48 sati.",
  moveToDraftOrCloneToEdit:
    "Premjestite ga u nacrt ili ga klonirajte za uređivanje",
  webContent: "Web sadržaj",
  eLearning: "E-učenje",
  untitledContent: "Sadržaj bez naslova",
  sendToDraft: "Pošalji u nacrt",
  sendToDraftPublishedInstruction:
    "Ovaj sadržaj je već objavljen. Za izmjene kliknite gumb Pošalji u nacrt.",
  copyLinkForLearner: "Kopiraj poveznicu za polaznika",
  questionPaperName: "Naziv upitnika",
  type: "Vrsta",
  duration: "Trajanje",
  minutes: "Minute",
  difficultyLevel: "Razina težine",
  language: "Jezik",
  timezone: "Vremenska zona",
  preferredLocation: "Preferirana lokacija",
  notSelected: "Nije odabrano",
  selectedPreferencesHeading: "Odabrane postavke",
  selectedPreferencesInfo: "Odabrane postavke za besprijekorno iskustvo",
  shortDescription: "Kratki opis",
  totalMarks: "Ukupni bodovi",
  questionPaperInstructions: "Upute za upitnik",
  expiryDate: "Datum isteka",
  knowledgeCategory: "Kategorija znanja",
  category: "Kategorija",
  subCategory: "Potkategorija",
  region: "Regija",
  usage: "Upotreba",
  internalUseOnly: "Samo za internu upotrebu",
  externalUseOnly: "Samo za vanjsku upotrebu",
  availableForAll: "Dostupno svima",
  apac: "APAC",
  emea: "EMEA",
  latinAmerica: "Latinska Amerika",
  northAmerica: "Sjeverna Amerika",
  globalRegion: "Globalno",
  automotive: "Automobilska industrija",
  bankingFinancialServicesInsurance:
    "Bankarstvo, financijske usluge i osiguranje",
  connectivitySolutionsCommunication: "Rješenja za povezivanje/komunikaciju",
  consumerRetail: "Potrošači i maloprodaja",
  healthcareLifeSciences: "Zdravstvo i znanosti o životu",
  manufacturingAndIndustrial: "Proizvodnja i industrija",
  mediaEntertainment: "Mediji i zabava",
  technology: "Tehnologija",
  other: "Ostalo",
  behavioralInterpersonal: "Bihevioralno/Interpersonalno",
  technical: "Tehničko",
  processAndTools: "Procesi i alati",
  polishLanguage: "Poljski",
  spanishLanguage: "Španjolski",
  japaneseLanguage: "Japanski",
  germanLanguage: "Njemački",
  ukrainianLanguage: "Ukrajinski",
  swedishLanguage: "Švedski",
  romanianLanguage: "Rumunjski",
  slovakLanguage: "Slovački",
  croatianLanguage: "Hrvatski",
  englishUsLanguage: "Engleski (US)",
  englishUkLanguage: "Engleski (UK)",
  englishInLanguage: "Engleski (IN)",
  netTech: "NET",
  aiMl: "AI/ML",
  automotiveStandardsProtocols: "Automobilski standardi i protokoli",
  businessAnalysis: "Poslovna analiza",
  cCpp: "C/C++",
  cloudDataScience: "Cloud data science",
  bigData: "Big Data",
  dataAnalytics: "Analitika podataka",
  databaseTech: "Baza podataka",
  developmentTools: "Razvojni alati",
  devops: "DevOps",
  embedded: "Ugrađeni sustavi",
  javaTech: "Java",
  javaScriptTech: "JavaScript",
  linuxKernel: "Linux kernel",
  mobileDev: "Mobilni razvoj",
  networking: "Mreže",
  operatingSystemsServers: "Operativni sustavi i poslužitelji",
  otherTech: "Ostalo - Tech",
  productivityTools: "Alati produktivnosti",
  programmingLangOther: "Programski jezici - Ostalo",
  pythonTech: "Python",
  phpTech: "PHP",
  qaAqa: "QA / AQA",
  softwareEngineering: "Softversko inženjerstvo",
  uxUi: "UX/UI",
  architectureTech: "Arhitektura",
  golang: "Golang",
  requirementEngineeringTechnicalWriting:
    "Inženjerstvo zahtjeva/Tehničko pisanje",
  onboarding: "Uvođenje",
  glTools: "GL alati",
  processAndPolicies: "Procesi i politike",
  communicationSubCategory: "Komunikacija",
  personalEffectiveness: "Osobna učinkovitost",
  methodologies: "Metodologije",
  projectManagement: "Upravljanje projektima",
  peopleManagement: "Upravljanje ljudima",
  leadershipPrograms: "Programi vodstva",
  domain: "Domena",
  reviewer: "Recenzent",
  none: "Nijedan",
  questionPaperPreviewBreadcrumb: "Pregled upitnika: {{title}}",
  questionPaperInReviewContactReviewer:
    "Ovaj upitnik je trenutno u recenziji. Molimo kontaktirajte recenzenta.",
  randomization: "Nasumični odabir",
  randomizationInSectionDescription:
    "Pitanja u ovom odjeljku kandidatima ce biti prikazana nasumicnim redoslijedom",
  questionPreviewPlaceholderImage: "Rezervirano mjesto za pregled pitanja",
  createNewVersionPromptWithNumber: "Stvoriti novu verziju (V{{version}})?",
  questionPreviewBreadcrumb: "Pregled pitanja: {{title}}",
  questionPreviewTitle: "Pregled pitanja",
  adminView: "Admin prikaz",
  candidateView: "Prikaz kandidata",
  viewAsCandidate: "Prikazi kao kandidat",
  closePanel: "Zatvori panel",
  internalQuestion: "Interno pitanje",
  expiresOn: "Istjece",
  expiredLabel: "Isteklo",
  solutionNotAdded: "Rjesenje nije dodano",
  testCases: "Testni slucajevi",
  testCasesNotAdded: "Testni slucajevi nisu dodani",
  starterCodeNotAdded: "Pocetni kod nije dodan",
  groupTitleLengthValidation:
    "Naslov grupe mora imati vise od 5 i manje od 120 znakova",
  addTitleHere: "Dodajte naslov ovdje...",
  groupUpdatedSuccessfully: "Grupa je uspjesno azurirana",
  groupDeletedSuccessfully: "Grupa je uspjesno obrisana",
  group: "Grupa",
  numberOfQuestionsToBeShown: "Broj pitanja za prikaz",
  questionLimitPerSectionDescription:
    "Prikazite kandidatima samo odredeni broj pitanja u odjeljcima",
  numberOfQuestionsToShow: "Broj pitanja za prikaz {{picked}}/{{total}}",
  collapseGroup: "Sakrij grupu",
  expandGroup: "Prosiri grupu",
  groupSetupStartAddingQuestions:
    "Grupa je postavljena za ovaj odjeljak. Pocnite dodavati pitanja.",
  addMoreQuestions: "Dodaj jos pitanja",
  addQuestionFromLibrary: "Dodaj pitanje iz biblioteke",
  questionDeletedSuccessfully: "Pitanje je uspjesno obrisano",
  questionsShownCountUpdated: "Broj prikazanih pitanja je azuriran",
  failedToDeleteQuestion: "Brisanje pitanja nije uspjelo",
  caseSensitive: "Razlikuje velika i mala slova",
  caseSensitiveDescription:
    "Ako je ukljuceno, polaznici moraju unijeti odgovor s potpuno istim velikim i malim slovima.",
  enterYourAnswerBelow: "Unesite svoj odgovor ispod",
  caseSensitiveAnswerInfo:
    "Ovo pitanje razlikuje velika i mala slova pa unesite odgovore s tocnim velikim i malim slovima.",
  answerWithNumber: "Odgovor {{number}}",
  inviteEmailsPlaceholder:
    "korisnik1@globallogic.com,korisnik2@globallogic.com",
  visibleTestCases: "Vidljivi testni slucajevi",
  hiddenTestCases: "Skriveni testni slucajevi",
  visibleLabel: "Vidljivo",
  hiddenLabel: "Skriveno",
  responseSetting: "Postavke odgovora",
  recordingLimit: "Ogranicenje snimanja",
  minimumResponseDuration: "Minimalno trajanje odgovora",
  uploadLimit: "Ogranicenje prijenosa",
  practiceAllowed: "Vjezbanje dopusteno",
  standardEvaluationRubricInfo:
    "Ovo je standardna evaluacijska rubrika koja ce se koristiti za procjenu odgovora kandidata na ovo pitanje.",
  criteria: "Kriteriji",
  weightPercentage: "Tezina(%)",
  viewRemarks: "Prikaži napomene",
  input: "Unos",
  expectedOutput: "Očekivani izlaz",
  actualOutput: "Stvarni izlaz",
  untitledSection: "Neimenovana sekcija",
  testSectionDescription: "Opis testne sekcije",
  groupAddedSuccessfully: "Grupa je uspješno dodana",
  addGroupToSection: "Dodaj grupu u sekciju",
  deleteSection: "Obriši sekciju",
  questionPaperDetails: "Detalji papira s pitanjima",
  skillsInfoMessage:
    "Navedite ključne vještine koje ovaj papir s pitanjima namjerava evaluirati.",
  contentSettings: "Postavke sadržaja",
  stakeholderAndReview: "Zainteresirane strane i pregled",
  statusType: "Vrsta statusa",
  notReviewed: "Nije pregledano",
  sourceType: "Vrsta izvora",
  proficiency: "Stručnost",
  beginner: "Početnik",
  intermediate: "Srednji",
  advanced: "Napredno",
  wecp: "WECP",
  enterMarks: "Unesite oznake",
  removeSkill: "Ukloni vještinu",
  searchSkills: "Vještine pretraživanja",
  noSkillsFound: "Nisu pronađene vještine.",
  enterTag: "Unesite oznaku",
  enterOwner: "Unesite vlasnika",
  enterReviewer: "Unesite recenzenta",
  noUserWithRole: "Nije pronađen nijedan korisnik s tom ulogom",
  createSection: "Stvori odjeljak",
  untitledGroup: "Grupa bez naziva",
  createGroup: "Stvori grupu",
  collapseSections: "Sažmi odjeljke",
  expandSections: "Proširi odjeljke",
  assessmentNamePlaceholder: "Unesite naziv procjene",
  questionPaperTitleInfo: "Unesite jasan, opisni naslov za upitnik.",
  shortDescriptionPlaceholder: "Navedite kratak opis",
  shortDescriptionInfo: "Kratak sažetak koji objašnjava što pokriva upitnik.",
  questionPaperInstructionsInfo:
    "Napišite upute koje će kandidati vidjeti prije nego što započnu s upitnikom. Uključite važne pojedinosti poput pravila odjeljaka, formata pitanja, savjeta za navigaciju i smjernica za slanje.",
  questionPaperInstructionsPlaceholder:
    "Dodajte sve važne upute za učenike prije nego započnu ocjenjivanje - trajanje, kriterije prolaznosti, dopuštene alate ili smjernice.",
  totalMarksAutoCalculatedInfo:
    "Ukupni će se bodovi automatski izračunati na temelju broja pitanja odabranih za svaku grupu. Ako je broj pitanja za prikaz postavljen na 0, ta će grupa biti isključena iz ukupnih ocjena.",
  questionPaperType: "Vrsta papira s pitanjima",
  questionPaperTypeInfo: "Odaberite format upitnika.",
  durationInfo:
    "Postavite ukupno vremensko ograničenje za ispunjavanje upitnika (u minutama).",
  difficultyLevelInfo:
    "Odaberite očekivanu razinu težine na temelju iskustva kandidata.",
  languageInfo: "Odaberite jezik na kojem će biti predstavljen upitnik.",
  tagsInfo:
    "Dodajte ključne riječi kako biste pomogli drugima da pronađu ovaj upitnik putem pretraživanja.",
  selectCategory: "Odaberite kategoriju",
  createLevel: "Stvoriti",
  evaluate: "Ocijenite",
  analyze: "Analizirati",
  apply: "primijeniti",
  understand: "razumjeti",
  remember: "Zapamti",
  allowedCodingLanguagesRequiredInfo:
    "polje je potrebno samo kada dodate pitanja o kodiranju u upitnik.",
  knowledgeCategoryInfo:
    "Odaberite razinu kognitivnih vještina koju ovaj upitnik cilja, npr. Zapamti, Razumi, Primijeni.",
  allowedCodingLanguagesInfo:
    "Odaberite programske jezike dopuštene za kodiranje pitanja u ovom upitniku.",
  expiryDateInfo:
    "Postavite izborni datum nakon kojeg se ovaj upitnik više ne smije koristiti.",
  visibilityInfo: "Odaberite vidljivost upitnika",
  visibilityLockedInfo:
    "Nakon što je upitnik objavljen s javnom vidljivošću, sve ostale njegove verzije također će imati javnu vidljivost. Slično, ako je objavljeno kao privatno, sve će verzije ostati privatne.",
  reviewRequired: "Potreban pregled",
  reviewRequiredLockedInfo:
    "Postavka 'Review Required' sinkronizirana je u svim verzijama Question Paper-a. Ako je bilo koja verzija objavljena s omogućenim ili onemogućenim pregledom, ista će se postavka primijeniti na sve verzije i ne može se uređivati ​​pojedinačno.",
  reviewRequiredInfo:
    "Omogućite ako ovaj upitnik mora proći formalni postupak pregleda prije objavljivanja.",
  savingData: "Spremanje podataka...",
  questionDataSavedSuccessfully: "Podaci o pitanju uspješno su spremljeni",
  sendQuestionForReviewInstruction:
    "Kliknite gumb Pošalji na pregled kako biste ga poslali recenzentu da ga pregleda!",
  publishQuestionInstruction:
    "Kliknite na gumb za objavljivanje kako biste objavili pitanje.",
  noLearningContentAddedAfterSelectingYes:
    "Nijedan sadržaj za učenje nije dodan nakon odabira Da",
  expectedTimeInMinutes: "Očekivano vrijeme (u min.)",
  codingMarksAutoCalculatedInfo:
    "Ove se ocjene izračunavaju automatski na temelju skrivenih testnih slučajeva dodanih ovom pitanju",
  skillsInfoMessageQuestion:
    "Navedite specifične vještine koje će sudionici steći iz pitanja",
  skillsSubtitleQuestion: "Postavite vještine povezane s ovim pitanjem",
  allowedCodingLanguagesInfoQuestion:
    "Odaberite dostupne jezike za rješavanje ovog pitanja",
  selectCodingLanguages: "Odaberite jezike kodiranja",
  allLanguages: "Svi jezici",
  tagsInfoQuestion:
    "Navedite ključne riječi za kategorizaciju, opis i identifikaciju događaja",
  tagsSubtitleQuestion: "Postavite oznake za brzo pretraživanje",
  knowledgeCategorySubtitleQuestion:
    "Pomaže u kategorizaciji pitanja prema razini kognitivnih vještina.",
  explanationNotAvailableForSpeakingQuestion:
    "Objašnjenje nije dostupno za Govorno pitanje",
  ownerVersionSyncInfo:
    "Ako promijenimo vlasnika ove verzije, ona će se također ažurirati u svim stvorenim verzijama.",
  ownerInfoMessage: "Odaberite primarnog vlasnika(e) pitanja",
  ownerReviewerCannotBeSame: "vlasnik i recenzent ne mogu biti isti",
  reviewerInfoMessage:
    "Odaberite pojedinca ili grupu pojedinaca kao recenzente",
  stakeholdersUpdatedSuccessfully: "Dionici su uspješno ažurirani!",
  unexpectedErrorCreatingNewVersion:
    "Došlo je do neočekivane pogreške prilikom izrade nove verzije.",
  previewAndPublish: "Pregledajte i objavite",
  viewAnalytics: "Pogledajte analitiku",
  cloneQuestionPrompt: "Želite li klonirati ovo pitanje?",
  evaluationRubric: "Rubrika ocjenjivanja",
  problemStatement: "Iskaz problema",
  problemStatementPlaceholder: "Unesite izjavu o problemu ili izjavu za kviz",
  addOptionsAndMarkCorrectAnswer: "Dodajte opcije i označite točan odgovor",
  markCorrectAnswer: "Označite točan odgovor",
  addCorrectAnswer: "Dodaj točan odgovor",
  enterCorrectAnswerForBlank: "Unesite točan odgovor za prazno {{number}}",
  blankWithNumber: "Prazan {{number}}",
  addProblemStatementWithBlankToEnableAnswer:
    "Dodajte odgovarajuću izjavu o problemu s '&prazno' kako biste omogućili odgovor.",
  enterSolution: "Unesite rješenje",
  enterExplanation: "Unesite Objašnjenje",
  codingSolutionExplanationPlaceholder:
    "Ukratko objasnite logiku, pristup i rubne slučajeve kojima se upravlja u optimalnom rješenju",
  optionWithNumber: "Opcija {{number}}",
  enterExplanationForAnswer: "Unesite objašnjenje za odgovor {{number}}",
  addOptionToEnableExplanation:
    "Dodajte opciju {{number}} da omogućite objašnjenje.",
  enterExplanationForBlank: "Unesite objašnjenje za prazno {{number}}",
  addProblemStatementWithBlankToEnableExplanation:
    "Dodajte odgovarajuću izjavu o problemu s '&prazno' kako biste omogućili objašnjenje.",
  enterHint: "Unesite savjet",
  addUpTo3Hints: "Dodajte do 3 savjeta",
  addMoreOptions: "Dodajte još opcija",
  answer: "Odgovor",
  exitCodeBlockInfo:
    'Da biste izašli iz bloka koda, idite na kraj retka i kliknite "Enter" tri puta',
  fibBlankInsertionInfo:
    'Za dodavanje praznine odaberite tekst i kliknite na gumb "Umetni prazninu" ili ručno dodajte &blankN, gdje N može biti bilo koji cijeli broj, npr.: &blank1;',
  htmlEditorAccessInfo:
    "Da biste dodali kod ili imali kontrolu nad formatom, možete pristupiti uređivaču HTML-a klikom na ikonu za uređivanje",
  skillSelectionCannotBeEmpty: "Odabir vještina ne može biti prazan",
  maxDurationInfo:
    "Maksimalno dopušteno vrijeme korisniku za snimanje odgovora na ovo pitanje.",
  minDurationInfo:
    "Minimalno potrebno vrijeme snimanja koje korisnik mora ispuniti prije podnošenja svog odgovora.",
  uploadLimitInfo:
    "Koliko puta korisnik može ponovno snimiti svoj odgovor prije konačnog slanja.",
  textQuestionTitle: "Ovo je tekstualno pitanje",
  audioRecordQuestionTitle: "Ovo je pitanje za audio zapis",
  audioUploadQuestionTitle: "Ovo je pitanje za prijenos zvuka",
  videoRecordQuestionTitle: "Ovo je pitanje za video zapis",
  videoUploadQuestionTitle: "Ovo je pitanje o prijenosu videozapisa",
  subjectiveQuestionUploadConfigTitle:
    "Naslov konfiguracije prijenosa subjektivnog pitanja",
  recordingLimitInMinutes: "Ograničenje snimanja (u min.)",
  minimumResponseDurationInMinutes: "Minimalno trajanje odgovora (u min.)",
  recordingLimitLessThanTwenty: "Ograničenje snimanja mora biti manje od 20",
  recordingLimitGreaterThanOrEqualOne:
    "Ograničenje snimanja mora biti veće ili jednako 1",
  minimumDurationLessThanRecordingLimit:
    "Minimalno trajanje odgovora mora biti kraće od ograničenja snimanja",
  durationGreaterThanPointFive: "Trajanje mora biti veće od 0,5",
  uploadLimitGreaterThanZero: "Ograničenje prijenosa mora biti veće od 0",
  addFieldSelectCodingLanguagesInfo:
    "Da biste dodali {{fieldLabel}}, prvo odaberite dopuštene jezike kodiranja u odjeljku '{{basicDetails}}'.",
  basicDetails: "Osnovni detalji",
  loadingEditor: "Učitavanje uređivača...",
  run: "Pokreni",
  writingSolutionInLanguage: "Trenutno upisujete rješenje",
  changingToLanguageWillClearInput: "Mijenjanje u",
  unsavedChangesWillBeLostInLanguage: "Vaše nespremljene promjene u",
  changeLanguage: "Promjena jezika",
  testCase: "Testni slučaj",
  add: "Dodati",
  addMinimumVisibleAndHiddenTestCasesInfo:
    "Dodajte najmanje 2 vidljiva testna slučaja i 3 skrivena testna slučaja u nastavku",
  visibleToCandidatesForSelfEvaluation:
    "Vidljivo kandidatima za samovrednovanje",
  noVisibleTestCasesAddedYet:
    "Još nisu dodani vidljivi testni slučajevi. Pritisnite donji gumb da biste ga dodali.",
  visibleTestCasesCannotExceedTwenty:
    "Vidljivih testnih slučajeva ne može biti više od 20",
  addMoreVisibleTestCases: "Dodajte više vidljivih testnih slučajeva",
  maximumTestCasesLimitReached:
    "Dosegnuto je maksimalno ograničenje testnih slučajeva",
  hiddenToCandidatesRunsAfterSubmit:
    "Skriveno za kandidate, pokreće se nakon prijave kandidata",
  noHiddenTestCasesAddedYet:
    "Još nisu dodani skriveni testni slučajevi. Pritisnite donji gumb da biste ga dodali.",
  hiddenTestCasesCannotExceedTen:
    "Skrivenih testnih slučajeva ne može biti više od 10",
  addMoreHiddenTestCases: "Dodajte još skrivenih testnih slučajeva",
  hiddenTestCase: "Skriveni ispitni slučaj",
  visibleTestCase: "Vidljivi testni slučaj",
  someQuestionsCouldNotBeUpdated:
    "Neka pitanja nije bilo moguće ažurirati. Pregledajte pitanja i pokušajte ponovno.",
  publishSummary: "Objavi sažetak",
  sendForReviewSummary: "Pošaljite sažetak na pregled",
  moveToDraftSummary: "Prijeđi na nacrt sažetka",
  actionSummary: "Sažetak akcije",
  publishSummarySubtitle:
    "Evo sažetka vaše radnje objavljivanja. Pregledajte detalje u nastavku.",
  sendForReviewSummarySubtitle:
    "Evo sažetka vašeg zahtjeva za pregled. Pregledajte detalje u nastavku.",
  moveToDraftSummarySubtitle:
    "Ovo je sažetak vašeg prelaska na radnju nacrta. Pregledajte detalje u nastavku.",
  actionSummarySubtitle:
    "Evo sažetka vaše radnje. Pregledajte detalje u nastavku.",
  successfully: "Uspješno",
  failedTo: "Nije uspjelo",
  moveToDraft: "Premjesti u Nacrt",
  details: "pojedinosti",
  questionTitle: "Naslov pitanja",
  reason: "Razlog",
  showLess: "Prikaži manje",
  showMoreCount: "Prikaži još {{count}}",
  uploadedAllCountItems: "Preneseno sve {{count}} {{item}}",
  partiallyUploadedCountItems:
    "Djelomično preneseno {{successCount}}/{{totalCount}} {{item}}",
  users: "korisnika",
  questions: "pitanja",
  viewErrors: "Prikaži pogreške",
  errorsWithFileName: "Pogreške - {{fileName}}",
  inputIsRequired: "Potreban je unos",
  expectedOutputIsRequired: "Potreban je očekivani rezultat",
  expectedOutputCannotBeBlank:
    "Očekivani izlaz ne smije biti prazan ili samo razmaci",
  marksMustBeNumber: "Oznake trebaju biti brojevi",
  marksAreRequired: "Oznake su obavezne",
  hiddenTestCaseMarksGreaterThanZero:
    "Oznake za skrivene testne slučajeve trebaju biti veće od 0 da biste nastavili.",
  hiddenTestCaseMarksMaxThirtyThousand:
    "Ocjene za skrivene testne slučajeve ne bi trebale premašiti 30.000.",
  explanationMinFiveIfProvided:
    "Objašnjenje mora imati najmanje 5 znakova ako je navedeno",
  explanationIsRequired: "Objašnjenje je potrebno",
  explanationMinFiveNotBlank:
    "Objašnjenje mora imati najmanje 5 znakova, a ne samo razmake",
  provideInput: "Unesite unos",
  provideExpectedOutput: "Osigurajte očekivani rezultat",
  enterScore: "Unesite rezultat",
  optional: "neobavezan",
  explainTestCase: "Objasnite test slučaj",
  updateTestCase: "Ažurirajte testni slučaj",
  addTestCase: "Dodaj testni slučaj",
  deleteQuestionWithTitlePrompt:
    "Jeste li sigurni da želite izbrisati ovo pitanje pod nazivom '{{title}}'?",
  errorFetchingData: "Pogreška pri dohvaćanju podataka",
  rowNumber: "Broj reda",
  columnName: "Naziv stupca",
  useCase: "Slučaj upotrebe",
  startsAt: "Počinje u",
  endsAt: "Završava u",
  invite: "Pozvati",
  viewReport: "Pogledaj izvješće",
  successfullyDeletedAssessment: "Procjena je uspješno izbrisana",
  successfullyFreezeActionAssessment: "Uspješno {{action}} ocjenjivanje",
  freezeOperationFailed: "Operacija zamrzavanja nije uspjela",
  deleteAssessmentWithTitlePrompt:
    "Jeste li sigurni da želite izbrisati ovu procjenu pod nazivom '{{title}}'?",
  freeze: "Zamrznuti",
  unfreeze: "Odmrzni",
  freezeAssessmentPrompt: "Jeste li sigurni da želite {{action}} ovu procjenu?",
  expiresAt: "Istječe u",
  seePreview: "Pogledajte Pregled",
  schedule: "Raspored",
  skillBenchmarking: "Usporedba vještina",
  skillBenchmarkingOverview:
    "Pregled sudionikove stručnosti u određenim vještinama.",
  proctoringAnalysis: "Proctoring analiza",
  proctoringAnalysisOverview:
    "Kratki pregled aspekata procjene koji se odnose na proctoring.",
  proctoringStatus: "Status nadziranja",
  noIrregularitiesReported: "Nema prijavljenih nepravilnosti.",
  monitoringOverview: "Pregled praćenja",
  complianceNoIncidents:
    "Usklađenost s pravilima ocjenjivanja; nema incidenata ili označenih ponašanja.",
  viewEvidenceClicked: "Kliknuti dokazi!",
  marksObtained: "Dobivene ocjene",
  correctAnswer: "Točan odgovor",
  wrongAnswer: "Pogrešan odgovor",
  sectionWiseAnalysis: "Analiza odjeljaka",
  sectionWiseAnalysisOverview: "Pregled svakog pitanja i odgovor kandidata.",
  openAllSections: "Otvorite sve odjeljke",
  closeAllSections: "Zatvorite sve odjeljke",
  sectionWithNumber: "Odjeljak {{number}}:",
  score: "Postići",
  questionAnalysis: "Analiza pitanja",
  questionTitleFallback: "Naslov pitanja",
  candidateAnswer: "Kandidat Odgovor",
  loadAllQuestions: "Učitaj sve {{count}} {{item}}",
  attemptWithNumber: "Pokušaj #{{number}}",
  invalidReportUrl: "Nevažeći URL izvješća",
  failedToDownloadReportTryAgainLater:
    "Preuzimanje izvješća nije uspjelo. Pokušajte ponovno kasnije!",
  downloadReport: "Preuzmi izvješće",
  participantName: "Ime sudionika",
  dateOfAttempt: "Datum pokušaja",
  fail: "neuspjeh",
  pass: "Proći",
  userScoredInAssessment: "{{name}} je postigao {{percentage}} u ocjenjivanju.",
  overallSummary: "Opći sažetak",
  sectionAnalytics: "Odjeljak Analitika",
  allAttempts: "Svi pokušaji",
  bestAttempt: "Najbolji pokušaj",
  latestAttempt: "Najnoviji pokušaj",
  participantList: "Popis sudionika",
  totalParticipantsInvited: "Ukupan broj pozvanih sudionika",
  notStarted: "Nije započeto",
  inProgress: "U tijeku",
  resultsInProgress: "Rezultati u tijeku",
  searchByNameOrEmail: "Pretražujte po imenu ili e-pošti",
  noUsersAvailableReportCannotBeGenerated:
    "Nema dostupnih korisnika - izvješće se ne može generirati.",
  userName: "Korisničko ime",
  totalAttempt: "Totalni pokušaj",
  percentage: "Postotak(%)",
  attemptTimeline: "Vremenska crta pokušaja",
  noDataFound: "Nema pronađenih podataka",
  outOfMarks: "{{obtained}} od {{max}} bodova",
  resultInProcess: "Rezultat u procesu",
  participantNotFound: "Sudionik nije pronađen!",
  searchedParticipantNotFound: "Traženi sudionik nije pronađen!",
  noParticipantEnrolled: "Nema upisanih sudionika!",
  noDataToDisplay: "Nema podataka za prikaz",
  participantsPerPage: "Sudionici po stranici:",
  actionFailed: "Radnja nije uspjela",
  failedToRemoveUser: "Uklanjanje korisnika nije uspjelo",
  bestScoreAcrossAttemptsInfo:
    "Označava najbolji rezultat postignut u više pokušaja.",
  successfullyRemovedUser: "Korisnik je uspješno uklonjen",
  successfullyReinvitedUser: "Korisnik je uspješno ponovno pozvan",
  reinviteTooltip:
    "Ponovno pozovite sudionike koji još nisu započeli procjenu koja je u tijeku",
  reInvite: "Ponovno pozvati",
  noParticipantsInvitedYet: "Još nema pozvanih sudionika",
  scheduleExpired: "Raspored je istekao",
  assessmentIsOngoing: "Procjena je u tijeku",
  assessmentCompleted: "Procjena dovršena",
  resultNotProcessed: "Rezultat nije obrađen",
  assessmentNotStarted: "Ocjenjivanje nije započeto",
  remove: "Ukloniti",
  confirmReInvitation: "Potvrdite ponovni poziv",
  confirmReinviteMessage:
    "Jeste li sigurni da želite ponovno pozvati sudionike koji još nisu započeli procjenu koja je u tijeku?",
  removeUserWithNamePrompt: "Jeste li sigurni da želite ukloniti '{{name}}'?",
  groupType: "Vrsta grupe",
  objectiveGroupType: "Cilj",
  codingGroupType: "Kodiranje",
  subjectiveTextSpeakingGroupType: "Subjektivno (tekst/govor)",
  groupTypeImmutableInfo:
    "Vrsta grupe ne može se kasnije promijeniti. Mogu se dodavati samo pitanja tog tipa.",
  sameMarkGroupingTitle:
    "Pitanja se mogu grupirati samo ako imaju istu vrijednost bodova",
  sameMarkGroupingDescription:
    "Miješanje vrijednosti bodova (npr. 2 boda i 5 boda) u grupi može dovesti do različitih rezultata odjeljaka kada su odabrana samo neka pitanja. Grupirajte pitanja sa sličnim oznakama kako bi rezultati bili dosljedni.",
  searchQuestion: "Traži pitanje",
  addAllSelectedQuestions: "Dodaj svih {{count}} odabranih pitanja",
  singleQuestionSelectedCount: "{{count}} pitanje odabrano",
  allQuestionsSelectedCount: "Svih {{count}} pitanja odabrano",
  selectedCountOfTotalQuestions: "Odabrano {{selected}} od {{total}} {{label}}",
  addSelectedQuestion: "Dodajte odabrano pitanje",
  validationErrors: "Pogreške provjere valjanosti",
  failedToAddToGroup: "Dodavanje u grupu nije uspjelo",
  questionsAddedSuccessfullyWithCount: "{{count}} pitanja uspješno dodana",
  successfullyUpdatedAssessment: "Procjena je uspješno ažurirana",
  editCustomTnc: "Uredi prilagođene uvjete korištenja",
  addCustomTnc: "Dodaj prilagođene uvjete korištenja",
  attributes: "Atributi",
  added: "Dodano",
  addAttributes: "Dodaj atribute",
  clickHereToAddEditAttributes:
    "Kliknite ovdje za dodavanje ili uređivanje atributa",
  clickHereToAddAttributes: "Kliknite ovdje za dodavanje atributa",
  addTncAndSave: "Dodaj uvjete korištenja i spremi",
  savedWithFollowingErrors: "Spremljeno sa sljedećim pogreškama",
  selectDomain: "Odaberite domenu",
  selectRegion: "Odaberite regiju",
  selectUsage: "Odaberite upotrebu",
  selectCategoryFirst: "Najprije odaberite kategoriju",
  selectSubCategory: "Odaberite potkategoriju",
  addAttributesAndSave: "Dodaj atribute i spremi",
  questionPaperTimer: "Mjerač vremena za ispitna pitanja",
  sectionLevelTimer: "Mjerač vremena na razini odjeljka",
  questionLevelTimer: "Mjerač vremena na razini pitanja",
  loginWindowDescription:
    "Kandidati se mogu pridružiti samo unutar ograničenog vremenskog prozora nakon vremena početka.",
  durationBasedDescription:
    "Vrijeme završetka automatski se izračunava iz vremena početka + trajanja testa.",
  deadlineDescription:
    "Fiksno vrijeme početka i završetka; kandidati moraju završiti prije isteka roka.",
  loginWindowInfo:
    "Prozor za prijavu je vrijeme (u minutama) tijekom kojeg kandidati mogu započeti procjenu nakon zakazanog vremena početka. Nakon što se prozor za prijavu zatvori, novi kandidati ne mogu pristupiti. Prozor za prijavu mora biti kraći od trajanja ispita ili jednak njemu.",
  assessmentDurationInfo:
    "Postavite samo vrijeme početka. Sustav će automatski izračunati vrijeme završetka dodavanjem trajanja testa.",
  startTimeMinAheadInfo:
    "Vrijeme početka mora biti najmanje 15 minuta ispred trenutnog vremena.",
  loginWindowExample:
    "Primjer: Ako je vrijeme početka 9:00, a prozor za prijavu 30 minuta, kandidati mogu započeti između 9:00 i 9:30 uz dodatnih 5 minuta tolerancije.",
  assessmentDurationExample:
    "Primjer: Ako je vrijeme početka 9:00, a trajanje testa 60 minuta, procjena će završiti u 10:00 uz dodatnih 5 minuta tolerancije.",
  freeFlow: "Slobodan tijek",
  oneByOne: "Jedno po jedno",
  subjectiveNoResultInfo: "Subjektivne informacije o statusu 'Bez rezultata'",
  candidateResultVisibility: "Vidljivost rezultata za kandidate",
  noResult: "Nema rezultata",
  passPercentageRangeError: "Pogreška u rasponu postotka za prolaz",
  attemptsAllowedInfo: "Informacije o dopuštenim pokušajima",
  maxAttemptsError: "Pogreška: Premašen maksimalan broj pokušaja",
  maximumAttemptsInfo: "Informacije o maksimalnom broju pokušaja",
  limitedAttempts: "Ograničeni pokušaji",
  coolOffDescription: "Opis razdoblja čekanja (hlađenja)",
  noCoolOffPeriod: "Bez razdoblja čekanja",
  waitFor: "Pričekaj",
  hours: "Sati",
  days: "Dani",
  whatLearnersWillSee: "Što će polaznici vidjeti",
  unlimitedAttemptsInfo: "Imate neograničen broj pokušaja za ovu procjenu.",
  waitBeforeNextAttemptPrefix: "Nakon svakog pokušaja morat ćete pričekati",
  waitBeforeNextAttemptSuffix: "prije nego što započnete sljedeći pokušaj.",
  waitBeforeNextAttempt:
    "Nakon svakog pokušaja morat ćete pričekati {duration} prije nego što započnete sljedeći pokušaj.",
  singleAttemptInfo: "Imate 1 pokušaj dostupan za ovu procjenu.",
  remainingAttemptsInfoPrefix: "Imate",
  remainingAttemptsInfoMiddle: "od",
  remainingAttemptsInfoSuffix: "pokušaja dostupnih za ovu procjenu.",
  remainingAttemptsInfo:
    "Imate {remaining} od {total} pokušaja dostupnih za ovu procjenu.",
  enableCertificate: "Omogući certifikat",
  enableCertificateDescription:
    "Izdajte certifikat kandidatima nakon uspješno završene procjene.",
  maxAllowed100: "Dopušteno je najviše 100",
  scheduleAssessment: "Zakazivanje procjene",
  privateAssessmentLabel: "Privatna procjena",
  publicAssessmentLabel: "Javna procjena",
  privateAssessmentDescription:
    "Ova procjena je dostupna samo putem pozivnice i isključivo unutar definiranog vremenskog prozora početka i završetka.",
  publicAssessmentDescription:
    "Ova procjena podržava i samododijeljeni i pristup putem pozivnice, bez fiksnog vremenskog prozora pristupa.",
  schedulePublicAssessment: "Zakazivanje javne procjene",
  successfullyPublishedAssessment: "Procjena je uspješno objavljena",
  publishWithoutProctoringPrompt: "Objaviti bez nadzora (proctoringa)?",
  publishAssessmentPrompt: "Objaviti procjenu?",
  sectionScoreAnalysis: "Analiza bodova po odjeljcima",
  sectionScoreAnalysisOverview: "Pregled analize bodova po odjeljcima",
  section: "Odjeljak",
  noSectionDataAvailable: "Nema dostupnih podataka za odjeljak",
  difficultyLevelAnalysis: "Analiza razine težine",
  browserViolations: "Prekršaji preglednika",
  videoViolations: "Prekršaji videozapisa",
  times: "Puta",
  statusMessageUnavailable: "Poruka o statusu nedostupna",
  viewViolationEvidence: "Pogledaj dokaze o prekršaju",
  noBrowserViolationsDetected: "Nisu otkriveni prekršaji preglednika",
  noVideoViolationsDetected: "Nisu otkriveni prekršaji videozapisa",
  candidateNotAttemptedCodingMessage:
    "Poruka: Kandidat nije pokušao riješiti programski zadatak",
  candidateCode: "Kod kandidata",
  candidateScore: "Bodovi kandidata",
  compilationCount: "Broj kompilacija",
  submissionCount: "Broj predaja",
  timeTaken: "Utrošeno vrijeme",
  testCaseReport: "Izvještaj o testnim slučajevima",
  performanceAndCompilationMetrics: "Metrika izvedbe i kompilacije",
  totalTestCases: "Ukupno testnih slučajeva",
  testCasesPassed: "Prošli testni slučajevi",
  testCaseDetails: "Detalji testnog slučaja",
  searchQuestions: "Pretraži pitanja",
  clearSearch: "Očisti pretragu",
  question: "pitanje",
  isSelected: "je odabrano",
  areSelected: "su odabrana",
  selected: "Odabrano",
  questionsPerPage: "Pitanja po stranici:",
  publishQuestions: "Objavi pitanja",
  send: "Pošalji",
  move: "Premjesti",
  publishQuestionsConfirmation:
    "Jeste li sigurni da želite objaviti {{count}} {{label}}?",
  sendForReviewConfirmation:
    "Jeste li sigurni da želite poslati {{count}} {{label}} na pregled?",
  moveToDraftConfirmation:
    "Jeste li sigurni da želite premjestiti {{count}} {{label}} u skice?",
  bulkPublishDisclaimer:
    "Molimo provjerite jesu li sva odabrana pitanja potpuna, točna i prikazana kako je predviđeno prije objavljivanja.",
  bulkReviewDisclaimer:
    "Molimo provjerite jesu li sva odabrana pitanja potpuna, točna i prikazana kako je predviđeno prije slanja na pregled.",
  bulkDraftDisclaimer:
    "Molimo provjerite jesu li sva odabrana pitanja potpuna, točna i prikazana kako je predviđeno prije premještanja u skice.",
  questionsUnderProcess:
    "Pitanja su u obradi, molimo kliknite na 'prikaži detalje' kako biste provjerili status pitanja.",
  mixedStatusesSelected: "Odabrani su mješoviti statusi",
  mixedStatusesWarning:
    "Molimo provjerite imaju li sva odabrana pitanja isti status prije nego što nastavite.",
  selectionLimitReached: "Dosegnuto ograničenje odabira",
  selectionLimitWarning:
    "Ne možete odabrati više od {{count}} pitanja za masovnu radnju. Odznačite jedno pitanje prije odabira drugog.",
  knowMore: "Saznajte više",
  guideLearnersRightDepth:
    "Vodite svoje polaznike pitanjima koja odgovaraju pravoj razini dubine.",
  bloomCreateDescription:
    "Procijenite sposobnost učenika da dizajnira, projektira arhitekturu ili izgradi nove sustave ili kodna rješenja koristeći više koncepata.",
  bloomEvaluateDescription:
    "Provjerite može li učenik kritički procijeniti kod, opravdati izbore ili vrednovati različita rješenja.",
  bloomAnalyzeDescription:
    "Testirajte sposobnost učenika da rastavi kod, ukloni pogreške, prati logiku ili identificira obrasce u tehničkim sustavima.",
  bloomApplyDescription:
    "Procijenite može li učenik primijeniti koncepte za rješavanje praktičnih problema kodiranja ili scenarija iz stvarnog svijeta.",
  bloomUnderstandDescription:
    "Provjerite može li učenik razumjeti i objasniti koncepte vlastitim riječima ili interpretirati ponašanje.",
  bloomRememberDescription:
    "Procijenite sposobnost učenika da se prisjeti osnovnih definicija, sintakse i činjeničnih informacija.",
  bloomVerbCreate: "Stvori",
  bloomVerbDesign: "Dizajniraj",
  bloomVerbConstruct: "Konstruiraj",
  bloomVerbDevelop: "Razvij",
  bloomVerbEvaluate: "Evaluiraj",
  bloomVerbJustify: "Opravdaj",
  bloomVerbDefend: "Brani",
  bloomVerbAssess: "Procijeni",
  bloomVerbAnalyze: "Analiziraj",
  bloomVerbDifferentiate: "Razlikuj",
  bloomVerbOrganize: "Organiziraj",
  bloomVerbCompare: "Usporedi",
  bloomVerbApply: "Primijeni",
  bloomVerbUse: "Koristi",
  bloomVerbDemonstrate: "Demonstriraj",
  bloomVerbSolve: "Riješi",
  bloomVerbExplain: "Objasni",
  bloomVerbDescribe: "Opiši",
  bloomVerbSummarize: "Sažmi",
  bloomVerbInterpret: "Interpretiraj",
  bloomVerbList: "Navedi",
  bloomVerbDefine: "Definiraj",
  bloomVerbName: "Imenuj",
  bloomVerbRecall: "Prisjeti se",
  bloomVerbRecognize: "Prepoznaj",
  bloomCreateExample1:
    "Stvorite aplikaciju na jednoj stranici koristeći React i Redux.",
  bloomCreateExample2:
    "Dizajnirajte shemu za bazu podataka aplikacije za dijeljenje vožnje.",
  bloomCreateExample3: "Razvijte CI/CD cjevovod koristeći GitHub Actions.",
  bloomEvaluateExample1:
    "Procijenite prednosti i nedostatke korištenja NoSQL-a u odnosu na SQL u arhitekturi mikrousluga.",
  bloomEvaluateExample2:
    "Preporučite poboljšanja za optimizaciju performansi React komponente.",
  bloomAnalyzeExample1: "Usporedite performanse merge sorta i quicksorta.",
  bloomAnalyzeExample2:
    "Analizirajte korištenje memorije ove rekurzivne funkcije.",
  bloomAnalyzeExample3:
    "Kategorizirajte pogreške u ovom bloku JavaScript koda.",
  bloomApplyExample1:
    "Primijenite algoritam binarnog pretraživanja za pronalaženje elementa u nizu.",
  bloomApplyExample2:
    "Koristite petlju za ispis Fibonaccijevog niza u Pythonu.",
  bloomApplyExample3:
    "Riješite problem iz stvarnog svijeta koristeći hash mapu.",
  bloomUnderstandExample1: "Objasnite kako stog radi koristeći LIFO princip.",
  bloomUnderstandExample2:
    "Opišite razliku između var, let i const u JavaScriptu.",
  bloomUnderstandExample3: "Interpretirajte izlaz zadanog SQL upita.",
  bloomRememberExample1:
    "Identificirajte ispravnu HTML oznaku za izradu hiperveze.",
  bloomRememberExample2:
    "Navedite četiri stupa objektno orijentiranog programiranja (OOP).",
  bloomRememberExample3: "Navedite primitivne tipove podataka u Javi.",
  commonVerbs: "Uobičajeni glagoli",
  exampleQuestions: "Primjeri pitanja",
  noExamplesAvailable: "Nema dostupnih primjera.",
  candidateResponse: "Odgovor kandidata",
  correctQuestions: "Točna pitanja",
  totalQuestions: "Ukupno pitanja",
  correctQuestionPercentage: "Postotak točnih pitanja",
  performance: "Izvedba",
  level: "RAZINA",
  noOfQuestions: "BROJ PITANJA",
  correctAttempts: "TOČNI POKUŠAJI",
  correctness: "TOČNOST",
  partiallyCorrect: "DJELOMIČNO TOČNO",
  partiallyCorrectPercentage: "POSTOTAK DJELOMIČNO TOČNIH",
  rescheduleAssessmentPrompt:
    "Molimo potvrdite želite li odgoditi procjenu pod nazivom „{{title}}“",
  assessmentAlreadyStarted: "Procjena je već započela",
  readMore: "Pročitaj više",
  best: "Najbolje",
  latest: "Najnovije",
  allQuestions: "Sve Pitanja",
  myQuestions: "Moja Pitanja",
  publicQuestions: "Javna Pitanja",
  remarks: "Napomene",
  addRemarks: "Dodaj Napomenu",
  noGroupsAdded: "Još nema dodanih grupa",
  addGroupInfo:
    "Započnite stvaranjem grupe kako biste počeli dodavati pitanja. Kliknite na gumb „Dodaj grupu u odjeljak” u nastavku da biste započeli.",
  exitPreview: "Izađi iz pregleda",
  preview: "Pregled",
  problemStatementNotAdded: "Opis problema nije dodan",
  durationDayUnit: "dan",
  durationDaysUnit: "dana",
  durationHourUnit: "sat",
  durationHoursUnit: "sati",
  durationMinuteUnit: "min",
  customFieldAddedForSingleLanguage:
    "Prilagođeno polje {{fieldLabel}} dodano za {{current}} od {{total}} jezik",
  customFieldAddedForMultipleLanguages:
    "Prilagođeno polje {{fieldLabel}} dodano za {{current}} od {{total}} jezika",
  email: "E-pošta",
  tagInputHint: "Dodajte odvojeno zarezom",
  enterOptions: "Unesite opcije",
  groupNotFound: "Grupa nije pronađena",
  sheetNotFound: "List nije pronađen",
  missingHeaders: "Obvezni zaglavlja nedostaju",
  assetNotFound: "Resurs nije pronađen",
  noValidDataFound: "Nisu pronađeni valjani podaci",
  notFoundPID: "Sudionik nije pronađen.",
  invalidParticipants: "Nevažeći sudionik.",
  alreadyAdded: "Sudionik je već dodan.",
  duplicateData: "Pronađeni su duplikati podataka.",
  invalidData: "Nevažeći podaci.",
  warnings: "Upozorenja",
  assignedToMyself: "Dodijeljeno meni (Samouloga)",
  assignedByMe: "Dodijeljeno od strane mene (Moji Zadaci)",
  urlCopiedToClipboard: "URL kopiran u međuspremnik!",
  failedToCopyUrl: "Greška pri kopiranju URL-a.",
  content: "Sadržaj",
  platformHelp: "Pomoć za platformu",
  privacyPolicy: "Politika privatnosti",
  logout: "Odjava",
  logoutConfirmTitle: "Jeste li sigurni da se želite odjaviti?",
  logoutConfirmDescription:
    "Odlazite? Uvijek se možete vratiti i nastaviti tamo gdje ste stali.",
  stayEngaged: "Ostani angažiran"
} as const;
export default hr;
